// TermSheetRegistry client helpers (viem over the injected wallet; registry address/chain come from the backend).
import { createPublicClient, createWalletClient, custom, http } from "viem";
import artifact from "@/contracts/TermSheetRegistry.json";

export const REGISTRY_ABI = artifact.abi;
export const REGISTRY_BYTECODE = artifact.bytecode;

export const CHAINS = {
  11155111: { name: "Ethereum Sepolia", rpc: "https://ethereum-sepolia-rpc.publicnode.com", explorer: "https://sepolia.etherscan.io", symbol: "ETH", faucet: "https://cloud.google.com/application/web3/faucet/ethereum/sepolia" },
  80002: { name: "Polygon Amoy", rpc: "https://rpc-amoy.polygon.technology", explorer: "https://amoy.polygonscan.com", symbol: "POL", faucet: "https://faucet.polygon.technology" },
  84532: { name: "Base Sepolia", rpc: "https://sepolia.base.org", explorer: "https://sepolia.basescan.org", symbol: "ETH", faucet: "https://docs.base.org/base-chain/tools/network-faucets" },
  137: { name: "Polygon", rpc: "https://polygon-rpc.com", explorer: "https://polygonscan.com", symbol: "POL" },
  1: { name: "Ethereum", rpc: "https://ethereum-rpc.publicnode.com", explorer: "https://etherscan.io", symbol: "ETH" },
  31337: { name: "Local Hardhat / Anvil", rpc: "http://127.0.0.1:8545", explorer: "", symbol: "ETH" },
};

export const chainOf = (id) => ({ id: Number(id), name: `chain ${id}`, nativeCurrency: { name: "ETH", symbol: "ETH", decimals: 18 }, rpcUrls: { default: { http: [CHAINS[id]?.rpc || ""] } }, ...(CHAINS[id] ? { name: CHAINS[id].name, nativeCurrency: { name: CHAINS[id].symbol, symbol: CHAINS[id].symbol, decimals: 18 } } : {}) });

export const hasWallet = () => typeof window !== "undefined" && !!window.ethereum;

export const walletClients = async () => {
  if (!hasWallet()) throw new Error("No browser wallet found — install MetaMask (or another EIP-1193 wallet) to anchor on-chain.");
  const transport = custom(window.ethereum);
  const wallet = createWalletClient({ transport });
  const [account] = await wallet.requestAddresses();
  const chainId = await wallet.getChainId();
  const chain = chainOf(chainId);
  return { wallet: createWalletClient({ account, chain, transport }), pub: createPublicClient({ chain, transport }), account, chainId };
};

export const switchChain = async (chainId) => {
  const hex = "0x" + Number(chainId).toString(16);
  try { await window.ethereum.request({ method: "wallet_switchEthereumChain", params: [{ chainId: hex }] }); }
  catch (e) {
    if (e?.code !== 4902 || !CHAINS[chainId]) throw e;
    const c = CHAINS[chainId];
    await window.ethereum.request({ method: "wallet_addEthereumChain", params: [{ chainId: hex, chainName: c.name, rpcUrls: [c.rpc], nativeCurrency: { name: c.symbol, symbol: c.symbol, decimals: 18 }, blockExplorerUrls: c.explorer ? [c.explorer] : [] }] });
  }
};

export const readRegistry = (chainId, address) => createPublicClient({ chain: chainOf(chainId), transport: http(CHAINS[chainId]?.rpc) }).readContract.bind(null, { address, abi: REGISTRY_ABI });

export const txUrl = (chainId, tx) => (CHAINS[chainId]?.explorer ? `${CHAINS[chainId].explorer}/tx/${tx}` : null);
export const addrUrl = (chainId, a) => (CHAINS[chainId]?.explorer ? `${CHAINS[chainId].explorer}/address/${a}` : null);
export const short = (s) => (s ? `${s.slice(0, 10)}…${s.slice(-6)}` : "—");
